'use strict';

/*global services*/
/*global createObjectCallBack*/

function LogoutAlert() {
  this.init();
}

LogoutAlert.prototype = $.extend({}, {
  constructor: 'LogoutAlert',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $('body').on('click', '#btn-logout', function (event) {
      event.preventDefault();
      _this.openLogoutAlertForm();
      return false;
    });
  },

  //----------------------------------------------------------------------------

  openLogoutAlertForm: function openLogoutAlertForm() {
    var _this = this;

    var modal = services.get('modal');
    modal.empty().open({
      title: services.get('translator').trans('security.logout.logout'),
      saveBtnTitle: services.get('translator').trans('security.logout.logout_confirm'),
      height: 'auto',
      width: 'md',
      modalClass: 'search-form',
      submitCallBack: createObjectCallBack(_this, 'submitLogoutAlertFrom'),
      form: true,
      keyboardClose: false
    });
    modal.content('<div class="signpost-wrapper">' + services.get('translator').trans('security.logout.logout_text') + '</div>');

    return _this;
  },

  submitLogoutAlertFrom: function submitLogoutAlertFrom() {
    var _this = this;
    var modal = services.get('modal');
    window.location.href = $('#btn-logout').data('href');
    modal.close();
    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;
    _this.registerCallbacks();
    return _this;
  }
});
